import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { AttackEventQuery } from '../../../components/attack-event/attack-event-query'
import { AttackEventDetail } from '../../../components/attack-event/attack-event-details'
import { css } from '@emotion/css'

export interface AttackEventDetailWrapperProps {
  readonly attackEventID: string
  readonly organizationID: string
}

function AttackEventDetailWrapper({
  attackEventID,
  organizationID
}: AttackEventDetailWrapperProps) {
  if (!attackEventID) {
    throw new Error('attackEventID is a required prop')
  }
  if (!organizationID) {
    throw new Error('organizationID is a required prop')
  }

  return (
    <AttackEventQuery
      attackEventID={attackEventID}
      organizationID={organizationID}
    >
      {({ attackEvent }) => {
        return (
          <AttackEventDetail
            organizationId={organizationID}
            attackEvent={attackEvent}
            className={css`
              margin-left: 1em;
            `}
          />
        )
      }}
    </AttackEventQuery>
  )
}

export const reactAttackEventDetail = createNgReactBridgeDirective(
  'reactAttackEventDetail',
  [],
  AttackEventDetailWrapper,
  ['attackEventID', 'organizationID']
)
